import { render, staticRenderFns } from "./PdfVue.vue?vue&type=template&id=161052d2&"
import script from "./PdfVue.vue?vue&type=script&lang=js&"
export * from "./PdfVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports